import { ItemList } from '../../orm'

class UserCourseReportList extends ItemList {
    getEntityKey() {
        return "admin/user_report"
    }
}

export const adminUserCourseReportList = new UserCourseReportList("admin_user_course_report__default")
